import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, setLogLevel } from 'firebase/firestore';

// Your web app's Firebase configuration using environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

let app;
let auth;
let db;

// FIX: Check that the environment variables are loaded before initializing Firebase.
// This prevents the app from crashing with an "invalid-api-key" error.
if (firebaseConfig.apiKey && firebaseConfig.projectId) {
  // Initialize Firebase safely
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

  // Initialize and export Firebase services
  auth = getAuth(app);
  db = getFirestore(app);

  // Optional: Enable debug logging for Firestore
  setLogLevel('debug');
} else {
  console.error("Firebase configuration is missing or incomplete. Please ensure you have a valid .env.local file in your project's root and have restarted the development server.");
}


export { app, auth, db };
